import { render, staticRenderFns } from "./dettaglio_filtri.vue?vue&type=template&id=68ed6619"
import script from "./dettaglio_filtri.vue?vue&type=script&lang=js"
export * from "./dettaglio_filtri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports